export default "__VITE_ASSET__25d56b06__"